import { Component, Input } from '@angular/core';

@Component({
  selector: 'getm-price-display',
  templateUrl: './price-display.component.html',
  styleUrls: ['./price-display.component.scss'],
})
export class PriceDisplayComponent {

  @Input() price: number = 0;
  @Input() priceColor: string = 'getm-neutral-dark';
  @Input() discount: number = 0;
  @Input() discountColor: string = 'getm-neutral-light';

  constructor() { }

}
